import { useCallback, useEffect, useLayoutEffect, useMemo, useRef, useState } from 'react';
import Header from '@/components/index/Header';
import LeftPanel from '@/components/index/LeftPanel';
import Footer from '@/components/index/Footer';
import cls from 'classnames';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Autoplay, Navigation, Pagination, Scrollbar } from 'swiper/modules';
import Brand from '@/components/index/Brand';
import ProTypes from '@/components/index/ProTypes';
import Production from '@/components/index/Production';
import Request from '@/utils/Request';
import styles from './index.module.scss';
import { DownOutlined, UpOutlined } from '@ant-design/icons';
import { Button } from 'antd';
export default () => {
  const [extend, setExtend] = useState<boolean>(false);
  const [dataSource, setDataSource] = useState<Record<string, any>>({});
  const [videoH, setVideoH] = useState<number>(729);
  const bannerRef = useRef<any>();
  const videoRef = useRef<any>();
  const videCurrentRef = useRef<boolean>(true);
  const [cookieVisible, setCookieVisble] = useState<boolean>(false);
  const htmlDecode = useCallback((str: string) => {
    let temp: any = document.createElement('div');
    temp.innerHTML = str;

    const output = temp.innerText || temp.textContent;
    temp = null;
    return output;
  }, []);
  const loadData = useCallback(async () => {
    const res = await Request.post('/home', {});
    if (res.errno === 0) {
      let dataStr = JSON.stringify(res.data);
      dataStr = htmlDecode(dataStr);
      const dataJson = JSON.parse(dataStr);
      setDataSource(dataJson);
    }
  }, [htmlDecode]);
  const gotoDetail = useCallback((item: any) => {
    if (item.redirectUrl) {
      window.open(item.redirectUrl);
    }
  }, []);
  const changeSwiper = useCallback(() => {
    videoRef?.current?.load();
    setTimeout(() => {
      console.log('videCurrentRef.current===', videCurrentRef.current);
      if (videCurrentRef.current) {
        videoRef?.current?.play();
      } else {
        videoRef?.current?.pause();
      }
    }, 100);
  }, []);
  useEffect(() => {
    loadData();
  }, [loadData]);
  const setCookie = useCallback((cvalue: string) => {
    const d = new Date();
    d.setTime(d.getTime() + 1000 * 24 * 60 * 60 * 1000);
    const expires = 'expires=' + d.toUTCString();
    document.cookie = 'canUseCookie=' + cvalue + '; ' + expires;
  }, []);
  useLayoutEffect(() => {
    setTimeout(() => {
      const width = bannerRef.current.offsetWidth;
      const h = (width * 880) / 1480;
      setVideoH(h);
      videoRef?.current?.play();
    }, 200);
    console.log('document.cookie===', document.cookie);
    const cookieStr = document.cookie;
    if (cookieStr.indexOf('canUseCookie') < 0) {
      setCookieVisble(true);
    }
    // document.body.addEventListener('click', () => {
    //   videoRef.current.muted = false;
    // });
  }, [setCookie]);
  const setCookieHandle = useCallback(
    (flag: string) => {
      setCookie(flag);
      setCookieVisble(false);
    },
    [setCookie]
  );
  const cookieDom = useMemo(() => {
    return (
      <div className={cookieVisible ? styles['full-modal'] : cls(styles['full-modal'], styles['disabled'])}>
        <div className={cls(styles['cookie-tips-waper'], 'flex', 'v-center')}>
          <p style={{ fontSize: '13px' }} className="flex1">
            本网站使用如我们的隐私政策所述的 Cookie
            和相关技术，目的包括网站运营、分析、增强用户体验或广告。您可以选择同意我们使用这些技术，或管理您自己的偏好。
          </p>
          <Button className={styles['cookie-btn']} type="primary" onClick={() => setCookieHandle('1')}>
            接受
          </Button>
          <Button className={styles['cookie-btn']} type="primary" ghost onClick={() => setCookieHandle('0')}>
            拒绝
          </Button>
        </div>
      </div>
    );
  }, [cookieVisible]);
  return (
    <div className={styles['index-container']}>
      {cookieDom}
      <Header />
      <div className={styles['main-content']}>
        <div className={styles['banner-waper']}>
          <div className={extend ? cls(styles['left-waper'], styles['fixed']) : styles['left-waper']}>
            <LeftPanel links={dataSource?.navigation} />
            <div className={styles['button-arrow-content']}>
              {extend ? (
                <span className={styles['arrow-btn']} onClick={() => setExtend(false)}>
                  <UpOutlined />
                  <span>点击收起</span>
                </span>
              ) : (
                <span className={styles['arrow-btn']} onClick={() => setExtend(true)}>
                  <DownOutlined />
                  <span>点击展开</span>
                </span>
              )}
            </div>
          </div>
          <div className={styles['banner']} ref={bannerRef}>
            {dataSource && (
              <Swiper
                autoplay={{ delay: 5000, pauseOnMouseEnter: true }}
                modules={[Navigation, Scrollbar, Pagination, Autoplay]}
                className="container"
                spaceBetween={0}
                slidesPerView={1}
                navigation
                onSlideChange={changeSwiper}
                pagination={{ clickable: true }}
              >
                {(dataSource.slideshow || []).map((item: any, index: number) => {
                  const type = item.url.substring(item.url.lastIndexOf('.') + 1, item.url.length);
                  return (
                    <SwiperSlide className="card" key={item.url}>
                      {({ isActive }: { isActive: boolean }) => {
                        console.log('isActive====', isActive);
                        if (isActive && index === 0 && type === 'mp4') {
                          videCurrentRef.current = true;
                        } else if (index === 0 && type === 'mp4' && !isActive) {
                          videCurrentRef.current = false;
                        }
                        return type === 'mp4' && index === 0 ? (
                          <>
                            <video
                              onClick={() => gotoDetail(item)}
                              ref={videoRef}
                              className={styles['banner-video']}
                              style={{ height: `${videoH}px`, objectFit: 'fill' }}
                              id={`${item.url}`}
                              src={item.url}
                              loop={true}
                              preload="auto"
                              controls={false}
                              muted={true}
                            ></video>
                          </>
                        ) : (
                          <img src={item.url} onClick={() => gotoDetail(item)} />
                        );
                      }}
                    </SwiperSlide>
                  );
                })}
              </Swiper>
            )}
          </div>
        </div>
        <div className={cls(styles['main'])}>
          <div className={cls(styles['brand-waper'], 'mt30')}>
            <div className={styles['sub-title']}>品牌专区</div>
            <Brand brands={dataSource.brand} />
          </div>
          <div className={cls(styles['type-waper'], 'mt30')}>
            <div className={styles['sub-title']}>产品种类</div>
            <ProTypes types={dataSource.goodsCategory} />
          </div>
          <div className={cls(styles['type-waper'], 'mt30')}>
            <div className={styles['sub-title']}>热销产品</div>
            <Production list={dataSource.goods} />
          </div>
        </div>
      </div>
      <Footer />
    </div>
  );
};
